import { useParams } from "react-router";
import { Address } from "viem";

import { useAuth } from "@/hooks/useAuth";

export const useProfileWalletAddress = () => {
  const { address } = useParams();
  const { address: currentUserAddress, isLoading } = useAuth();
  const addressToUse =
    address === "me" ? currentUserAddress : (address as Address);
  return {
    profileAddress: addressToUse,
    isCurrentUserAddress: address === currentUserAddress || address === "me",
    isLoading: !addressToUse && isLoading ? false : isLoading,
  };
};
